module.exports = __webpack_public_path__ + "img/board_layout_1.4e1ec705.png";